import type { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { validGroupId } from 'src/shared/validatorUtils';

export const groupIdsRule = (): Rule => {
  const { t } = useTranslation();

  return ({
    message: t('Please enter correct group IDs'),
    validator: (_, value: string[]) => (
      value.every((groupId) => validGroupId(groupId))
        ? Promise.resolve()
        : Promise.reject()
    ),
  });
};
